export default __webpack_public_path__ + "static/media/rnr-sports-table-26-cn.379d559d.webp";